import {
  Attachment01,
  ChevronDown,
  ItalicSquare,
  Microphone02,
} from "@untitledui/icons"
import type { FormEvent, HTMLAttributes } from "react"

import { Avatar } from "@/components/base/avatar/avatar"
import { Button } from "@/components/base/buttons/button"
import { ButtonUtility } from "@/components/base/buttons/button-utility"
import { TextAreaBase } from "@/components/base/textarea/textarea"
import { cx } from "@/utils/cx"

export interface MessageActionAdvancedProps
  extends Omit<HTMLAttributes<HTMLFormElement>, "onSubmit"> {
  onSubmit?: (message: string) => void
  textAreaClassName?: string
}

export const MessageActionAdvanced = ({
  className,
  onSubmit,
  textAreaClassName,
  ...props
}: MessageActionAdvancedProps) => {
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.target as HTMLFormElement)
    const message = formData.get("message") as string
    onSubmit?.(message)
  }

  return (
    <form
      className={cx(
        "bg-secondary ring-secondary relative flex h-max flex-col rounded-xl ring-1 ring-inset",
        className,
      )}
      onSubmit={handleSubmit}
      {...props}
    >
      <div className="relative flex">
        <TextAreaBase
          aria-label="Message"
          placeholder="Ask me anything..."
          name="message"
          className={cx("h-32 w-full resize-y rounded-xl", textAreaClassName)}
        />
        <ButtonUtility
          icon={Microphone02}
          size="xs"
          color="tertiary"
          className="absolute top-2 right-2"
        />
      </div>

      <div className="flex w-full items-center justify-between gap-3 px-3 py-2">
        <div className="flex cursor-pointer items-center gap-1">
          <Avatar
            size="xs"
            alt="Olivia Rhye"
            src="https://www.untitledui.com/images/avatars/olivia-rhye?fm=webp&q=80"
            className="size-4"
          />
          <div className="flex items-center gap-0.5">
            <p className="text-tertiary truncate text-xs font-semibold">
              Olivia{" "}
            </p>
            <ChevronDown className="text-fg-quaternary size-3 stroke-3" />
          </div>
        </div>

        <div className="flex items-center gap-3">
          <Button
            size="sm"
            color="link-gray"
            iconLeading={<ItalicSquare data-icon className="size-4!" />}
            className="text-xs font-semibold"
          >
            Shortcuts
          </Button>
          <Button
            size="sm"
            color="link-gray"
            iconLeading={<Attachment01 data-icon className="size-4!" />}
            className="text-xs font-semibold"
          >
            Attach
          </Button>
        </div>
      </div>
    </form>
  )
}
